module.exports = __webpack_public_path__ + "img/hm.622ba887.svg";